import React, { useEffect } from 'react';

import { Text } from '../atom/Text';
import { Flex } from '../atom/Layout';
import { ButtonWithLogo } from './ButtonWithLogo';

import logoNaver from '../../../lib/image/icons/logo/naverLogo.svg';
import * as PATH from '../../../lib/routes/path';
import { isProductionEnv } from '../../../lib/util/Environment';
import { SocialLoginIcon } from '../atom/SocialLoginIcon';

export const NaverLoginButton = ({...props}) => {
  // 공식 문서 방식: 네이버 OAuth URL 직접 생성
  const handleNaverLogin = () => {
    const clientId = isProductionEnv
      ? process.env.REACT_APP_CLIENT_ID
      : process.env.REACT_APP_CLIENT_ID_NAVER_DEV;
    
    const callbackUrl = `${
      isProductionEnv
        ? process.env.REACT_APP_ORIGIN_URL
        : process.env.REACT_APP_ORIGIN_URL_NAVER_DEV
    }${PATH.SIGNIN_NAVER}`;
    
    // 공식 문서 3.4.2: 네이버 로그인 연동 URL 생성
    const state = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
    const naverLoginUrl = `https://nid.naver.com/oauth2.0/authorize?response_type=code&client_id=${clientId}&state=${encodeURIComponent(state)}&redirect_uri=${encodeURIComponent(callbackUrl)}`;
    
    console.log('네이버 로그인 URL:', naverLoginUrl);
    
    // 네이버 로그인 페이지로 리다이렉트
    window.location.href = naverLoginUrl;
  };

  return (<>
    { props.icon ?
      <>
        <SocialLoginIcon
          logo={logoNaver}
          style={{ backgroundColor: '#2db400', fontWeight: 400 }}
          onClick={handleNaverLogin}
        />
      </>
    :
    <Flex column alignItems="stretch" style={props.style}>
      <ButtonWithLogo
        logo={logoNaver}
        style={{ backgroundColor: '#2db400', fontWeight: 400 }}
        onClick={handleNaverLogin}
      >
        <Text>네이버로 로그인</Text>
      </ButtonWithLogo>
    </Flex>
    }
  </>);
}